export const getConverterOptionsWithDefaults = options => {
  const converterOptions = Object.assign({
    isUngated: () => false,
    hasScope: () => false,
    useHoursFiltering: false
  }, options);
  return converterOptions;
};